const updateItems = [
  {
    date: '2026-07-28',
    title: '《斗破苍穹》漫画全集完结版完整收录上线',
    desc: '从废柴少年到炎帝萧炎，全卷漫画已完成完整收录。下拉式阅读体验，一次性看完经典玄幻热血漫画完整版。',
    tag: '上新',
  },
  {
    date: '2026-07-27',
    title: '《一人之下》最新话同步更新至第688话',
    desc: '异人世界的终极秘密即将揭晓，张楚岚与冯宝宝的命运走向何方？漫画全卷持续更新中，下拉阅读追更最方便。',
    tag: '更新',
  },
  {
    date: '2026-07-26',
    title: '下拉式阅读功能再优化，加载速度提升50%',
    desc: '技术团队对漫画全集阅读引擎进行重大升级，图片预加载和缓存策略全面优化，下拉式漫画阅读更加丝滑流畅。',
    tag: '公告',
  },
  {
    date: '2026-07-25',
    title: '《全职高手》完结版全卷阅读量突破千万',
    desc: '叶修归来引爆全网阅读热潮，荣耀之巅的故事感动无数读者。漫画大全平台中电竞类漫画热度持续攀升。',
    tag: '热门',
  },
  {
    date: '2026-07-24',
    title: '经典漫画《镇魂街》全卷资源重新整理上线',
    desc: '曹焱兵与守护灵的激燃冒险，漫画完整版经过全面数字化优化，画面更清晰，下拉式阅读一滑到底超爽体验。',
    tag: '上新',
  },
  {
    date: '2026-07-23',
    title: '移动端漫画阅读体验全面升级',
    desc: '手机和平板访问虫虫动漫的漫画全集页面现在适配更精准，横屏竖屏自动切换，阅读字体和画面比例智能调节。',
    tag: '公告',
  },
  {
    date: '2026-07-22',
    title: '《星辰变》全卷完结漫画收录完成',
    desc: '秦羽的修仙之路从凡间到神界的完整故事已全部收录。漫画完整版下拉一口气看完，修仙漫画爱好者不容错过。',
    tag: '上新',
  },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            更新动态
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            漫画全集平台最新资讯与漫画更新速递
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          {updateItems.map((item, idx) => {
            const tagColors: Record<string, string> = {
              '上新': 'bg-primary-100 text-primary-700',
              '更新': 'bg-accent-100 text-accent-700',
              '公告': 'bg-secondary-100 text-secondary-700',
              '热门': 'bg-primary-100 text-primary-700',
            };
            return (
              <div key={idx} className="relative pl-8 pb-8 last:pb-0">
                {idx < updateItems.length - 1 && (
                  <div className="absolute left-[11px] top-7 bottom-0 w-0.5 bg-background-200"></div>
                )}
                <div className="absolute left-0 top-1.5 w-[22px] h-[22px] rounded-full bg-primary-500 border-4 border-background-50 flex items-center justify-center">
                  <div className="w-1.5 h-1.5 rounded-full bg-white"></div>
                </div>
                <div className="bg-background-100 rounded-xl p-5">
                  <div className="flex items-center gap-3 mb-2 flex-wrap">
                    <span className="text-xs text-foreground-400 font-medium">{item.date}</span>
                    <span className={`inline-block px-2 py-0.5 text-xs font-medium rounded-full ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}